import PageTitle from 'components/ui/pageTitle/pageTitle'
import React from 'react'
import NewsletterForm from './components/newsletterForm/newsletterForm'

export default function Newsletter() {
  return (
    <>
      <PageTitle>Sign to newsletter</PageTitle>
      <NewsletterForm />
    </>
  )
}
